import {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import Container from "@components/layout/Container";
import {client, urlFor} from "@/services/sanityClient";

const QUERY = `*[_type == "graniteType" && showInMaterials == true] | order(order asc, _createdAt desc) {
  _id, title, image
}`;

const ArrowIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="50" height="15" viewBox="0 0 50 15" fill="none">
		<path d="M49.7071 8.07088C50.0976 7.68035 50.0976 7.04719 49.7071 6.65666L43.3431 0.292702C42.9526 -0.0978227 42.3195 -0.0978227 41.9289 0.292702C41.5384 0.683226 41.5384 1.31639 41.9289 1.70692L47.5858 7.36377L41.9289 13.0206C41.5384 13.4111 41.5384 14.0443 41.9289 14.4348C42.3195 14.8254 42.9526 14.8254 43.3431 14.4348L49.7071 8.07088ZM0 7.36377V8.36377H49V7.36377V6.36377H0V7.36377Z" fill="#005BBB" />
	</svg>
);

export default function Materials() {
	const [stones, setStones] = useState([]);

	useEffect(() => {
		client.fetch(QUERY).then(setStones);
	}, []);


	if (stones.length === 0) return null;

	return (
		<section className="materials">
			<Container>
				<div className="materials-grid">
					<div className="materials-left">
						<span className="eyebrow eyebrow--dark">Матеріали</span>
						<h2 className="h2-serif materials-title">
							Граніт — це <span style={{color: "rgba(0, 71, 160, 1)", fontStyle: "italic"}}>вічність</span>
						</h2>
						<p className="materials-desc">
							Ми працюємо тільки з природнім каменем — найміцнішою гірською
							породою. Кожен кар&apos;єр проходить сертифікацію якості перед
							тим, як ми беремо з нього матеріал.
						</p>
					</div>

					<div className="materials-list">
						{stones.map((stone) => (
							<div className="material-row" key={stone._id}>
								<div className="material-thumb">
									{stone.image && (
										<img
											src={urlFor(stone.image).width(120).height(120).fit("crop").auto("format").url()}
											alt={`Зразок граніту ${stone.title} для пам'ятника`}
											width="120"
											height="120"
											loading="lazy"
											decoding="async"
											crossOrigin="anonymous"
										/>
									)}
								</div>
								<span className="material-name">{stone.title}</span>
								<div className="material-end">
									<span className="material-arrow"><ArrowIcon /></span>
									<Link to="/catalog#vidy-granitu" className="material-cta">всі зразки</Link>
								</div>
							</div>
						))}
						<Link to="/catalog#vidy-granitu" className="materials-all-cta">всі зразки</Link>
					</div>
				</div>
			</Container>
		</section>
	);
}
